module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-400.0b22ddd0.woff";